import type { ChangeEvent } from 'react';
import { type Namespace, useTranslation } from 'react-i18next';
import { styled } from 'goober';

import { useDebounce } from '@/hooks/use-debounce';
import { modalState } from '@/state/modal.state';
import { Button } from '@/ui/button/button';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { Input } from '@/ui/input/input';
import { useSetAtom } from 'jotai';

export const UserSearch = ({
  onSearchInputChange,
  translationNamespace,
}: {
  onSearchInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  translationNamespace: Namespace;
}) => {
  const { t } = useTranslation(translationNamespace);
  const setModal = useSetAtom(modalState);

  const handleSearchInputChange = useDebounce(onSearchInputChange);
  const handleInviteUser = () => setModal({ state: 'inviteUser' });

  return (
    <FixedContainer
      padding="16px"
      name="search-for-users-container"
      gap="24px"
      justify="space-between"
    >
      <Input
        onChange={handleSearchInputChange}
        placeholder={t`searchForUsers`}
        width="100%"
        padding="4px 8px"
        fontSize="12px"
      />
      <Button startIcon="Plus" onClick={handleInviteUser}>
        {t`default:invite.inviteUser`}
      </Button>
    </FixedContainer>
  );
};

const FixedContainer = styled(Flexbox)`
  width: 400px;
`;
